import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from '@/pages/dashboard/Dashboard'
import _Switch from '@/pages/switch/Switch'
import AxleCounter from '@/pages/axlecounter/AxleCounter'
import AxleShunt from '@/pages/axleshunt/Index'
import SwitchReports from '@/pages/switch/SwitchReports'
import UserManagement from '@/pages/management/UserManagement'
import OrganisationManagement from '@/pages/management/OrganisationManagement'
import AlarmList from '@/pages/alarmlist/AlarmList'
import Search from '@/pages/search/Search'
import Languages from '@/i18n/lang/template/langtemplate'
import Users from '@/pages/users/Users'
import User from '@/pages/users/User'
import Organisations from '@/pages/organisations/Organisations'
import Organisation from '@/pages/organisations/Organisation'
import MixedSignals from '@/pages/mixedSignals/MixedSignals.vue'

import Diagnose from '@/pages/application/diagnose'
import Manuals from '@/pages/application/manuals'
import Settings from '@/pages/application/settings'
import Support from '@/pages/application/support'
import Termsofservice from '@/pages/application/termsofservice'
import Dashboard2 from '@/pages/dashboard2/Dashboard'
import Dashboard3 from '@/pages/dashboard3/Dashboard'

import login from '@/pages/login/Login'
import disclaimer from '@/pages/login/Disclaimer'
import verifyEmail from '@/pages/login/VerifyEmail'

import _error from '@/pages/login/_Error'
import _loaddata from '@/pages/login/_LoadData'
import _loginscreen from '@/pages/login/_LoginScreen'
import _support from '@/pages/login/_Support'
import _forgotPassword from '@/pages/login/_ForgotPassword'

// user validation check
import AuthenticationService from '@/services/AuthenticationService'
import http403 from '@/pages/httpcodes/403'

Vue.use(Router)

const router = new Router({
  routes: [
    // bounce pages
    {
      path: '/forbidden',
      name: '403',
      component: http403
    },
    {
      path: '/',
      name: 'Home',
      component: Dashboard
    },
    {
      path: '/lang',
      component: Languages
    },
    {
      path: '/login',
      name: 'Login',
      component: login,
      children: [
        {
          path: 'error',
          component: _error
        },
        // {
        //   path: 'loaddata',
        //   component: _loaddata
        // },
        {
          path: 'loginscreen',
          name: 'loginscreen',
          component: _loginscreen
        },
        {
          path: 'support',
          component: _support
        },
        {
          path: 'forgotpassword',
          component: _forgotPassword
        }
      ]
    },
    {
      path: '/loaddata',
      name: 'LoadData',
      component: _loaddata
    },
    {
      path: '/login/disclaimer',
      name: 'Disclaimer',
      component: disclaimer
    },
    {
      path: '/login/verifyEmail',
      name: 'VerifyEmail',
      component: verifyEmail
    },
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: Dashboard
    },
    {
      path: '/dashboard1',
      name: 'Dashboard1',
      component: Dashboard
    },
    {
      path: '/dashboard2',
      name: 'Dashboard2',
      component: Dashboard2
    },
    {
      path: '/dashboard3',
      name: 'Dashboard3',
      component: Dashboard3
    },
    {
      path: '/axlecounter/:railobjectid',
      name: 'AxleCounter',
      component: AxleCounter
    },
    {
      path: '/mixedsignals/:railobjectid',
      name: 'MixedSignals',
      component: MixedSignals
    },
    /*
    {
      path: '/axlecounter/:passedId?',
      name: 'AxleCounters',
      component: AxleCounter,
      props: (route) => {
        return {
          passedId: Number(route.params.passedId)
        }
      }
    }, */
    {
      path: '/axleshunt/:id',
      name: 'AxleShunt',
      component: AxleShunt,
      props: (route) => {
        return {
          id: Number(route.params.id)
        }
      }
    },
    {
      path: '/axleshunt/:id/periodic',
      name: 'AxleShunts',
      component: AxleShunt,
      props: (route) => {
        return {
          id: Number(route.params.id)
        }
      }
    },
    {
      path: '/reports',
      name: 'Reports',
      component: SwitchReports
    },
    // new
    {
      path: '/possusers',
      name: 'users',
      meta: {
        requiresAuth: true,
        minRole: 2
      },
      components: {
        'management-router': Users
      }
    },
    {
      path: '/possusers/new',
      name: 'new-user',
      component: User
    },
    {
      path: '/possusers/:id',
      name: 'user',
      component: User
    },
    {
      path: '/possorganisations',
      name: 'organisations',
      components: {
        'management-router': Organisations
      }
    },
    {
      path: '/possorganisations/edit/:id',
      name: 'organisation',
      components: {
        'management-router': Organisation
      }
    },
    // end of new
    {
      path: '/users/:id',
      name: 'User management',
      component: UserManagement
    },
    {
      path: '/users',
      name: 'Users management',
      component: UserManagement
    },
    {
      path: '/organisations',
      name: 'Organisations management',
      component: OrganisationManagement
    },
    {
      path: '/organisations/:id',
      name: 'Organisation management',
      component: OrganisationManagement
    },
    {
      path: '/switch',
      name: 'Switches',
      component: _Switch
    },
    {
      path: '/switch/:id',
      name: 'Switch',
      component: _Switch
    },
    {
      path: '/alarmlist',
      name: 'AlarmList',
      component: AlarmList
    },
    {
      path: '/switch/:id/:measurementId',
      name: 'SwitchMeasurement',
      component: _Switch
    },
    {
      path: '/switch/:id/:motorId/:measurementId',
      name: 'SwitchMotorMeasurement',
      component: _Switch
    },
    {
      path: '/search',
      name: 'Search',
      component: Search,
      props: (route) => ({
        alarm: route.query.alarm,
        warning: route.query.warning,
        maintenance: route.query.maintenance,
        text: route.query.text
      })
    },
    {
      path: '/diagnose',
      name: 'Diagnose',
      component: Diagnose
    },
    {
      path: '/manuals',
      name: 'Manuals',
      component: Manuals
    },
    {
      path: '/settings',
      name: 'Settings',
      component: Settings
    },
    {
      path: '/support',
      name: 'Support',
      component: Support
    },
    {
      path: '/termsofservice',
      name: 'TermsOfService',
      component: Termsofservice
    }
  ]
})

// Remove comment to see actual routes
router.beforeEach((to, from, next) => {
  // Dashboard route restriction (except the default dashboard)
  const dashboardPath = /^\/dashboard\d+$/
  if (dashboardPath.test(to.path)) {
    if (AuthenticationService.getUser() && !AuthenticationService.getUser().DashboardId) {
      return next({ name: '403' })
    }
  }

  // Authorization check for routes requiring authentication
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (AuthenticationService.getUser() !== null) {
      if (AuthenticationService.getUser().SystemRoleId >= to.meta.minRole) {
        next()
      } else {
        router.push({ name: '403' })
      }
    }
  }

  // Store last visited route in localStorage
  if (!to.path.includes('loaddata') && !from.path.includes('loaddata') &&
    !to.path.includes('Disclaimer') && !from.path.includes('Disclaimer')) {
    localStorage.setItem('lastRoute', to.path)
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js